"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hopinPlugin = void 0;
var hopinPlugin = function (config) { return ({
    name: 'hopin',
    config: config,
    methods: {
        trackEvent: function (_a) {
            var eventName = _a.eventName, eventProperties = _a.eventProperties, token = _a.token;
            return fetch("".concat(config.analyticsUrl, "/track_event"), {
                body: JSON.stringify({
                    event_name: eventName,
                    event_properties: eventProperties,
                }),
                headers: {
                    'Content-type': 'Application/json',
                    Authorization: "Bearer ".concat(token),
                },
                method: 'POST',
            });
        },
    },
}); };
exports.hopinPlugin = hopinPlugin;
//# sourceMappingURL=hopinPlugin.js.map